import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Column } from "react-table";
import Toast from "../../helpers/Toast";
import { CountersFromEquipmentRequestDTO } from "../../models/Equipment/CountersFromEquipmentRequestDTO";
import { PaginatedEquipmentCounterDTO } from "../../models/Equipment/PaginatedEquipmentCounterDTO";
import { EquipmentService } from "../../services/EquipmentService";
import TableComponent from "../TableComponent";

interface EquipmentCountersProps {
  equipmentId: number;
}

function EquipmentCounters({ equipmentId }: EquipmentCountersProps) {
  const equipmentService = React.useMemo(() => new EquipmentService(), []);
  const [data, setData] = useState<PaginatedEquipmentCounterDTO[]>([]);
  const pageSizes: number[] = [5, 15, 30];
  const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [goToPage, setGoToPage] = useState<number>();
  const [pageCount, setPageCount] = useState(1);

  const columns = React.useMemo<Column<object>[]>(() => [
    {
      Header: <FormattedMessage id="Screens.CounterTypes.Table.Code" />,
      accessor: "code",
      width: 12,
    },
    {
      Header: <FormattedMessage id="Screens.CounterTypes.Table.Name" />,
      accessor: "name",
      width: 12,
    },
    {
      Header: <FormattedMessage id="Screens.CounterTypes.Table.Unit" />,
      accessor: "unit",
      width: 12,
      Cell: ({ value }: any) => <span>{value ? value : "-"}</span>,
    },
  ], []);

  const fetchEquipmentCounters = async (page: number, pageSize: number) => {
    setIsLoading(true);

    const search: CountersFromEquipmentRequestDTO = {
      equipmentId: equipmentId,
      currentPage: currentPage,
      pageSize: pageSize,
    }

    var response = await equipmentService.GetCountersFromEquipment(search);

    if (response.success === false) {
      Toast.Show("error", response.message);
      setIsLoading(false);
      return;
    }

    setData(response.items);
    setIsLoading(false);
    setPageCount(response.totalPages);
    setPageSize(pageSize);
    setCurrentPage(page);
    setGoToPage(0)
  }

  useEffect(() => {
    if (equipmentId !== 0) {
      fetchEquipmentCounters(currentPage ?? 1, pageSize ?? 5)
    }
  }, [equipmentId, currentPage, pageSize])

  return (
    <div>
      <label style={{ margin: "0px", padding: "13px" }}><b><FormattedMessage id="Screens.Equipment.Counters" /></b></label>
      <TableComponent
        columns={columns}
        data={data}
        goToPage={goToPage}
        initialPage={currentPage}
        pageCount={pageCount}
        initialPageSize={pageSize}
        pageSizes={pageSizes}
        manualPagination={true}
        loading={isLoading}
        fetchData={fetchEquipmentCounters}
        initialSortBy={[]}
        disableSortBy={true}
      />
    </div>
  );
}

export default EquipmentCounters;
